export enum PaymentStatus {
  Pending = 1,
  Confirmed = 2,
  Canceled = 3,
  Refunded = 4,
}
